import { __assign } from "tslib";
// DS: i7.12
import React from 'react';
import IconWrap from '../../IconWrap';
var Quote = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9 7a1 1 0 01.993.883L10 8v4.764a1 1 0 01-.06.34l-.046.107-1.618 3.236a1 1 0 01-.77.545L7.383 17H6.5a.927.927 0 01-.875-1.234l.046-.108L7 13H5a1 1 0 01-.993-.883L4 12V8a1 1 0 01.883-.993L5 7h4zm10 0a1 1 0 01.993.883L20 8v4.764a1 1 0 01-.06.34l-.046.107-1.618 3.236a1 1 0 01-.77.545l-.124.008H16.5a.927.927 0 01-.875-1.234l.046-.108L17 13h-2a1 1 0 01-.993-.883L14 12V8a1 1 0 01.883-.993L15 7h4z" }))));
};
Quote.displayName = 'Quote';
export default Quote;
//# sourceMappingURL=Quote.js.map